import $ from 'jquery';

$(document).ready(function () {
  const $container = $('.left-right-images');
  function adjustLeftPadding() {
    if ($container.hasClass('two-images')) {
      if ($(window).width() <= 1024) {
        const $rightP = $('.right-side p');
        const $rightH = $('.right-side h2');
        const $leftSide = $('.left-side');
        const pHeight = $rightP.outerHeight();
        const imgHeight = $('.left-side > img');
        const iHeight = imgHeight.outerHeight();
        if (pHeight !== null) {
          const requiredPadding = pHeight + 50;
          $leftSide.css('top', requiredPadding + 'px');
          $rightH.css('padding-top', iHeight + 50 + 'px');
        }
      } else {
        $('.left-side').css('top', '');
        $('.right-side h2').css('padding-top', '');
      }
    } else {
      $('.left-side').css('top', '');
      $('.right-side h2').css('padding-top', '');
    }
  }

  adjustLeftPadding();
  $(window).resize(function () {
    adjustLeftPadding();
  });
});
